module.exports = __webpack_public_path__ + "static/studio-3-1d5451ced89eabb55683e27e070bdb60.jpg";